module.exports = __webpack_public_path__ + "media/images/login/gifu-fff9a5954c78ee510fd5e9ac21d9ace8.png";